<template>
  <el-card shadow="hover" :style="elCardColorHelp" class="form-group">
    <template #header>
      <div class="clearfix">
        <span>ヘルプ</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="$emit('help-close')">閉じる</el-button>
      </div>
    </template>
    <!-- Step1ダイアログ内 -->
    <el-row :gutter="50" v-if="status === 'step1'">
      <el-col :span="12">
        <dl>
          <dt>【N-ATR】</dt><dd>  ロスカットをATRの何倍にするか</dd>
          <dt>【ユニットの調整】</dt><dd>  小次郎講師流では取引対象に応じてユニットサイズを調整する（株：0.8など）</dd>
          <!-- <dt>【ユニットサイズ】</dt><dd>  仕掛けのATRで入力した値をもとに算出される。算出されたサイズでプラクティスを行う</dd> -->
        </dl>
      </el-col>
      <el-col :span="12">
        <dl>
          <dt>【投資用資金】</dt><dd>  初期の投資用資金を設定</dd>
          <!-- <dt>【調整後資金】</dt><dd>  投資用資金から、プラクティスの損益を反映した取引の計算用の資金。短期的な福利の運用にならないように、損失のみ反映する（利益を即座に反映すると複利のトレードになってしまう）</dd> -->
        </dl>
      </el-col>
    </el-row>
    <!-- プラクティス中 -->
    <el-row :gutter="50" v-else>
      <el-col :span="12">
        <dl>
          <dt>【N-ATR】</dt><dd>  ロスカットをATRの何倍にするか</dd>
          <dt>【ユニットの調整】</dt><dd>  小次郎講師流では取引対象に応じてユニットサイズを調整する（株：0.8など）</dd>
          <dt>【ユニットサイズ】</dt><dd>  仕掛けの「ATR」で入力した値をもとに以下の計算式で算出される。算出されたサイズを参考に取引量を決めてプラクティスを行う。計算式：投資用資金の１％（A）÷ ATR（B）✕ ユニットの調整（C）</dd>
        </dl>
      </el-col>
      <el-col :span="12">
        <dl>
          <dt>【投資用資金】</dt><dd>  初期の投資用資金を設定</dd>
          <!-- <dt>【調整後資金】</dt><dd>  投資用資金から、プラクティスの損益を反映した取引の計算用の資金。短期的な福利の運用にならないように、損失のみ反映する（利益を即座に反映すると複利のトレードになってしまう）</dd> -->
        </dl>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
export default {
  props: ['elCardColorHelp', 'status'],
  name: 'practice-help',
}
</script>
